// extracted by mini-css-extract-plugin
export default {"component":"styles__component--_Zt3R","fileIconPreview":"styles__fileIconPreview--eogdh","pdfPreview":"styles__pdfPreview--Rg3dq"};